import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import axios from 'axios';
import BoxSeatLogo from '../components/BoxSeatLogo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TermsOfServicePage() {
  const navigate = useNavigate();
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/terms-of-service`)
      .then(res => setTerms(res.data))
      .catch(err => console.error('Failed to load terms:', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-bg flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bg text-white">
      <header className="fixed top-0 w-full z-50 backdrop-blur-2xl bg-black/60 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/')} className="text-zinc-400 hover:text-white transition-colors"><ArrowLeft size={20} /></button>
            <BoxSeatLogo size="xs" onClick={() => navigate('/')} />
          </div>
        </div>
      </header>

      <main className="pt-24 pb-16 max-w-3xl mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-8">
          <FileText size={28} className="text-primary" />
          <h1 data-testid="terms-page-title" className="font-heading text-3xl sm:text-4xl font-black tracking-tighter uppercase">
            Terms of <span className="text-primary">Service</span>
          </h1>
        </div>

        {terms && (
          <div className="bg-surface border border-white/10 rounded-xl p-8 md:p-12">
            <p className="text-sm text-zinc-500 mb-6">Effective Date: {terms.effective_date}</p>
            <p className="text-zinc-300 mb-8 leading-relaxed italic border-l-2 border-primary pl-4">{terms.service_description}</p>

            <div className="space-y-8">
              {terms.sections?.map((section, i) => (
                <div key={i}>
                  <h2 className="font-heading text-xl font-bold uppercase mb-3 text-white">{section.heading}</h2>
                  <p className="text-zinc-400 leading-relaxed">{section.content}</p>
                </div>
              ))}
            </div>

            {terms.trademark_notice && (
              <div className="mt-12 pt-8 border-t border-white/10">
                <p className="text-xs text-zinc-600">{terms.trademark_notice}</p>
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
}
